import { render, staticRenderFns } from "./ChanDoanHinhAnh.vue?vue&type=template&id=d9563c14&scoped=true"
import script from "./ChanDoanHinhAnh.vue?vue&type=script&lang=js"
export * from "./ChanDoanHinhAnh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9563c14",
  null
  
)

export default component.exports